import { FC } from 'react'

const Error500: FC = () => {
  return (
    <>
      <h1 className='fw-bolder fs-4x text-gray-700 mb-10'>Error del sistema</h1>

      <div className='fw-bold fs-3 text-gray-400 mb-15'>
        ¡Algo salió mal! <br /> Por favor, inténtelo de nuevo más tarde.
        <br /><br />
        <span className='fs-4 text-warning fw-bolder'>
          Nota: Si ingresó con un perfil de Caja o Puesto, el acceso es exclusivo desde la Aplicación Móvil.
        </span>
      </div>
    </>
  )
}

export { Error500 }
